import { InventoryCategory, InventoryCategoryGuide } from "@contracts/interfaces/inventory-category";


class InventoryCategoryFactory {
    public static featuresComponent = {
        component: "features",
        data: {
            title: "",
            allowAdditional: true,
            required: []
        }
    }

    public static default: InventoryCategory = {
        id: null,
        name: "",
        nicename: "",
        indented: false,
        archive: false,
        itemTemplate: [
            InventoryCategoryFactory.featuresComponent
        ],
        guide: {
            exampleItem: null
        }
    }

    public static validate(category: InventoryCategory): InventoryCategory {

        category.name = category.name || this.default.name;
        category.nicename = category.nicename || this.default.nicename;
        category.indented = category.indented || this.default.indented;
        category.archive = category.archive || this.default.archive;
        category.itemTemplate = category.itemTemplate || this.default.itemTemplate;
        category.itemTemplate = category.itemTemplate || this.default.itemTemplate;
        category.guide = category.guide || this.default.guide;

        // Ensure features component is always set
        let found = false;
        for (let template of category.itemTemplate) {
            if (template.component == "features") {
                found = true;
            }
        }

        if (!found) {
            category.itemTemplate.push(InventoryCategoryFactory.featuresComponent);
        }

        return category;
    }
}



export { InventoryCategoryFactory }